/**
 * @param {string|null} targetElement
 */
const resolveProductVariants = (targetElement = null) => {

  let s = "";

  if (targetElement) {
    s += `${targetElement} `;
  }
  
  s += `[data-module='variants']`;

  document.querySelectorAll(s).forEach((product) => {
    updateProductView(product);
  });
};

const resolveVariant = (variants, product) => {
  const location = getLocation();
  //console.log('resolveVariant - location:', location);
  //console.log('resolveVariant - all variants:', variants);

  // Try engraving variant first
  let selectedVariant = variants.find((variant) => {
    console.log('Checking engraving variant:', {
      id: variant.id,
      available: variant.available,
      price: variant.price,
      engraving: variant.engraving,
      engravingCheck: variant.engraving !== "true",
      stateCoverage: variant.stateCoverage,
      includesState: variant.stateCoverage?.includes(location.state)
    });

    if (!variant.available /*|| variant.price === 0*/ || variant.engraving !== "true") {
      return false;
    }

    // If no state coverage defined, accept the variant
    if (!variant.stateCoverage || !Array.isArray(variant.stateCoverage) || variant.stateCoverage.length === 0) {
      return true;
    }

    // Check if state is covered
    return variant.stateCoverage.includes(location.state);
  });

  // If no engraving variant, find regular variant
  if (!selectedVariant) {
    selectedVariant = variants.find((variant) => {
      if (!variant.available /*|| variant.price === 0*/) {
        return false;
      }

      // If no state coverage defined, accept the variant
      if (!variant.stateCoverage || !Array.isArray(variant.stateCoverage) || variant.stateCoverage.length === 0) {
        return true;
      }

      // Check if state is covered
      return variant.stateCoverage.includes(location.state);
    });
  }

  return selectedVariant;
};

/**
 * @returns {{state: string}}
 */
const getLocation = () => {
  return {
    state: getCustomerState(),
  };
};

/**
 * @param {object} product
 * @param {object|null} variant
 */
const updateProductView = (product, variant = null) => {
  console.log(
    "updateProductView called for product:",
    product,
    "with variant:",
    variant
  );

 

  if (!variant) {
    try {
      console.log(
        "No variant provided, parsing variants from product dataset..."
      );
      const variantList = JSON.parse(product.dataset.variants).sort(
        (a, b) => Number(a.price) - Number(b.price)
      );
      variant = resolveVariant(variantList, product);
      // delete product.dataset.variants;
    } catch (e) {
      console.error("Error parsing variants from product dataset:", e);
      variant = undefined;
    }
  }

  setProductAvailability(product, variant);
  toggleEngraving(product, variant?.engraving === "true");
};

/**
 * @param {object} product
 * @param {object} variant
 */
const setProductAvailability = (product, variant) => {
  const shippingDisclaimer = isPdp(product)
    ? product.querySelector(".shipping-disclaimer")
    : undefined;

  if (!variant?.available /*|| !variant?.price*/) {
    console.log(
      "Variant is out of stock or has no price, setting as out of stock..."
    );
    setProductOos(product, shippingDisclaimer);
    return;
  }

  console.log("Variant is in stock, setting as in stock...");
  setProductInStock(product, variant, shippingDisclaimer);
};

/**
 * @param {object} product
 * @param shippingDisclaimer
 */
const setProductOos = (product, shippingDisclaimer = null) => {
  console.log("setProductOos called for product:", product);

  const badge = product.querySelector(".badge.badge-sold-out");
  const buyButton = product.querySelector(".product-form__submit") || product.querySelector(".quick-add__submit");
  const priceContainer = product.querySelector(".price__container");

  if (buyButton) {
    buyButton.disabled = true;

    const soldOutMessage = buyButton.querySelector(".sold-out-message");
    console.log("soldOutMsg", soldOutMessage);
    if (soldOutMessage) {
      soldOutMessage.classList.remove("hidden");
      console.log("Showing sold out message.");
      buyButton.querySelectorAll("span:not(.sold-out-message)").forEach((e) => {
        e.classList.add("hidden");
      });
    }
  }

  if (priceContainer) {
    priceContainer.style.display = "none";
    console.log("Price container hidden.");
  }

  if (badge) {
    badge.style.display = "inline-block";
    badge.classList.remove("hidden");
    console.log("Sold out badge shown.");
  }

  if (shippingDisclaimer) {
    updateShippingDisclaimer(shippingDisclaimer, false);
  }

};

/**
 * @param {object} product
 * @param {object} variant
 * @param shippingDisclaimer
 */
const setProductInStock = (product, variant, shippingDisclaimer) => {

  const variantField = product.querySelector(
    "[data-type=add-to-cart-form] [name=id]"
  );
  const priceItem = product.querySelector(".price-item.price-item--regular");

  if (variantField) {
    variantField.value = variant.id;
    console.log("Variant field updated with variant ID:", variant.id);
  }

  if (priceItem) {
    priceItem.innerHTML = formatPrice(variant.price);
    console.log("Price updated:", formatPrice(variant.price));
  }
  if (shippingDisclaimer) {
    updateShippingDisclaimer(shippingDisclaimer, true);
  }
};

const updateShippingDisclaimer = (shippingDisclaimer, shippable) => {
  console.log(
    "updateShippingDisclaimer called with shippingDisclaimer:",
    shippingDisclaimer,
    "shippable:",
    shippable
  );

  if (shippable) {
    shippingDisclaimer.querySelector(".in-stock").classList.remove("hidden");
    console.log("In-stock message shown.");
  } else {
    shippingDisclaimer
      .querySelector(".out-of-stock")
      .classList.remove("hidden");
    shippingDisclaimer.querySelector(".in-stock").classList.add("hidden");
    console.log("Out-of-stock message shown.");
  }

  shippingDisclaimer.classList.add(shippable ? "in-stock" : "out-of-stock");
  shippingDisclaimer.querySelector(".selected-state").innerHTML =
    getLocation().state;
  console.log("Shipping disclaimer updated for state:", getLocation().state);
};

/**
 * Check if element is a card or product details view
 * @param {object} product
 * @returns {boolean}
 */
const isCard = (product) => {
  console.log("isCard called for product:", product);
  return product.dataset.view == "product_card";
};

/**
 * Check if element page is product details
 * @param {object} product
 * @returns {boolean}
 */
const isPdp = (product) => {
  return product.dataset.view == "product_details";
};

/**
 * @param {object} product
 */
const removeLoader = (product) => {
  console.log("removeLoader called for product:", product);

  if (product.querySelector(".price-loader")) {
    product.querySelector(".price-loader").classList.remove("price-loader");
    console.log("Removed price loader.");
  }

  product.querySelectorAll(".btn-loader").forEach((e) => {
    e.classList.remove("btn-loader");
    console.log("Removed button loader.");
  });
};

/**
 * @param {object} product
 * @param {boolean|null|undefined} engravingVariant
 */
function toggleEngraving(product, engravingVariant) {
  product.dataset.engraving = engravingVariant ? 'true' : 'false';

  const submitButton = product.querySelector('button[id$="-submit"]:not(.engraving-submit-btn)');
  const form = product.querySelector('form[data-type="add-to-cart-form"]');

  if (!submitButton || !form) {
    console.warn('Submit button or form not found for product');
    return;
  }

  // Wrap submit button in a button group container if not already done
  let btnWrapper = submitButton.closest('.quick-add__buttons');
  if (!btnWrapper) {
    btnWrapper = document.createElement('div');
    btnWrapper.className = 'quick-add__buttons';
    submitButton.parentNode.insertBefore(btnWrapper, submitButton);
    btnWrapper.appendChild(submitButton);
  }

  // Remove any existing personalize button
  const existing = btnWrapper.querySelector('.personalize-btn');
  if (existing) existing.remove();

  if (engravingVariant) {
    const formId = form.getAttribute('id') || '';
    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput ? variantInput.value : '';

    let maxChars = 20;
    let maxLines = 3;

    try {
      const variantList = JSON.parse(product.dataset.variants || '[]');
      const currentVariant = variantList.find(v => v.id == variantId);
      maxChars = currentVariant?.engravingMaxChars || 20;
      maxLines = currentVariant?.engravingMaxLines || 3;
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }

    // Create Personalize button
    const personalizeBtn = document.createElement('button');
    personalizeBtn.type = 'button';
    personalizeBtn.className = 'personalize-btn quick-add__submit button button--full-width button--secondary';
    personalizeBtn.textContent = 'ENGRAVE';
    personalizeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof openGlobalEngravingOverlay === 'function') {
        openGlobalEngravingOverlay(formId, variantId, maxChars, maxLines, true);
      }
    });

    // Insert Personalize before Add to Cart
    btnWrapper.insertBefore(personalizeBtn, submitButton);
    btnWrapper.classList.remove('quick-add__buttons--single');

    // Ensure Add to Cart stays native
    submitButton.type = 'submit';
    const btnText = submitButton.querySelector('.add-to-cart-text');
    if (btnText) btnText.textContent = 'ADD TO CART';

    console.log('Engraving enabled — two buttons shown');
  } else {
    btnWrapper.classList.add('quick-add__buttons--single');
    console.log('Engraving disabled — single Add to Cart button');
  }
}